export default __webpack_public_path__ + "static/media/phcnPhe.494b1461.svg";